import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/components/WebView/icons/BackLeftAction.svg'


const _withScopeId = n => (_pushScopeId("data-v-0abb72c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "composer-container" }
const _hoisted_2 = {
  key: 1,
  class: "placeholder"
}
const _hoisted_3 = {
  key: 2,
  class: "names"
}
const _hoisted_4 = { class: "editor" }
const _hoisted_5 = { class: "footer-container" }
const _hoisted_6 = { class: "notice-scheduler" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "notice-scheduler-label" }, "Publish Schedule:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "chevron" }, "▼", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_SelectedRecipientPills = _resolveComponent("SelectedRecipientPills")!
  const _component_ChatInput = _resolveComponent("ChatInput")!
  const _component_NoticeSchedulerModal = _resolveComponent("NoticeSchedulerModal")!
  const _component_WebViewScreen = _resolveComponent("WebViewScreen")!

  return (_openBlock(), _createBlock(_component_WebViewScreen, {
    class: "composer",
    "no-pad": "",
    "avoid-keyboard": "",
    title: _ctx.typeTitle
  }, {
    "left-button": _withCtx(() => [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "Back",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goPickNoticeType && _ctx.goPickNoticeType(...args)))
      })
    ]),
    "right-button": _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass([{ active: _ctx.canSend }, "send"]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSendNotices && _ctx.onSendNotices(...args)))
      }, _toDisplayString(_ctx.sendButtonText), 3)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "composer-option compact",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goPickRecipients && _ctx.goPickRecipients(...args)))
        }, [
          (_ctx.loadingPreselectedRecipient)
            ? (_openBlock(), _createBlock(_component_Loading, {
                key: 0,
                loading: _ctx.loadingPreselectedRecipient,
                contained: true
              }, null, 8, ["loading"]))
            : (!_ctx.hasRecipients)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Add Recipients "))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_SelectedRecipientPills, {
                    recipients: _ctx.recipients,
                    "selected-recipients": _ctx.selectedRecipients,
                    "can-remove-tabs": false
                  }, null, 8, ["recipients", "selected-recipients"])
                ]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_ChatInput, {
            "html-mode": "",
            "disable-auto-focus": "",
            placeholder: _ctx.chatInputPlaceholder,
            "custom-class": "notice-editor",
            class: "notice-editor-wrapper",
            "max-text-length": _ctx.wordLimit,
            content: _ctx.message,
            "on-update": _ctx.onMessageUpdate,
            mentions: _ctx.recipients
          }, null, 8, ["placeholder", "max-text-length", "content", "on-update", "mentions"])
        ]),
        _renderSlot(_ctx.$slots, "footer", {}, () => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", {
                class: "notice-scheduler-value",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleScheduleDateTimePicker && _ctx.toggleScheduleDateTimePicker(...args)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.scheduledTimeLabel) + " ", 1),
                _hoisted_8
              ])
            ])
          ])
        ], true)
      ]),
      _createVNode(_component_NoticeSchedulerModal, {
        show: _ctx.showSchedule,
        timezone: _ctx.timezone,
        onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSchedule = false)),
        onSchedule: _ctx.onScheduleTime
      }, null, 8, ["show", "timezone", "onSchedule"])
    ], undefined, true),
    _: 3
  }, 8, ["title"]))
}